export const MANAGE_MARKETING_IMAGES = "Manage Marketing Images ";
export const OF = "of ";
export const UPLOADED = "Uploaded";
export const ENABLE_DRAG_AND_DROP = "Enable Image Drag & Drop"

export const ERRORS = {
    INVALID_FILE_TYPE: "Invalid file type",
    FILE_TOO_LARGE: "File too large",
    TOO_MANY_FILES: "Too many images selected",
};